$(".in-index .products").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  centerMode: false,
  autoplay: false,
  dots: true,
  arrows: true,
  infinite: false,
  adaptiveHeight: false,
  responsive: [
    { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 } },
    { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 450, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
});
$(".type-detail .products-related").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  centerMode: false,
  autoplay: false,
  dots: true,
  arrows: true,
  infinite: false,
  adaptiveHeight: false,
  responsive: [
    { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 } },
    { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false } },
    { breakpoint: 400, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
});
$(".in-index .categories .wrap").slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  centerMode: false,
  autoplay: false,
  dots: true,
  arrows: true,
  infinite: false,
  adaptiveHeight: false,
  responsive: [
    { breakpoint: 1199, settings: { slidesToShow: 4, slidesToScroll: 1 } },
    { breakpoint: 991, settings: { slidesToShow: 4, slidesToScroll: 1 } },
    { breakpoint: 767, settings: { slidesToShow: 3, slidesToScroll: 1, arrows: false } },
    { breakpoint: 550, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 400, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
});
if ($(".slick-slider:not(.id-1036 .prodejny):not(.id-1039 .gallery)").length) {
  $(".slick-slider").each(function () {
    var $wrapper = $('<div class="arrowWrapper"></div>');
    $(this).find(".slick-dots").after($wrapper);

    var $arrows = $(this).find(".slick-arrow");

    if ($arrows.length) {
      $arrows.each(function () {
        var $arrow = $(this);

        $arrow.appendTo($wrapper);
      });
    }
  });
}

$(".id-1036 .prodejny").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: false,
  autoplay: false,
  dots: true,
  arrows: true,
  infinite: false,
});
$(".pobocky .wrap.list span").on("click", function () {
  $(".actual").text($(this).text());
  $(this).addClass("hidden").siblings().removeClass("hidden");
  let slideIndex = $(this).data("slide");

  $(".prodejny").slick("slickGoTo", slideIndex);
});

$(".id-1039 .gallery .wrap").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  centerMode: false,
  autoplay: false,
  dots: true,
  arrows: true,
  infinite: false,
  adaptiveHeight: false,
  responsive: [
    { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 } },
    { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false } },
    { breakpoint: 400, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: false } },
  ],
});
